export default "__VITE_ASSET__ac1d4cad__"